import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/base-components';
import { setSelectedCallerID } from '@rsos/reduxDataStore';
import { conversationStateValues } from '@rsos/reduxDataStore/src/features/conversations/conversations.typings';
import { getCallerIDFromConversation } from '@rsos/reduxDataStore/src/features/conversations/utils';
import { getToastButtonText, getToastIcon, getToastMessage } from './helpers';

const ViewButton = styled(Button).attrs({
  btnType: 'secondary',
  noMargin: true,
})`
  height: 28px;
`;

export interface ConversationsToastProps {
  conversation: conversationStateValues;
  handleButtonClick?: () => void;
}

const ConversationsToast = ({
  conversation,
  handleButtonClick,
}: ConversationsToastProps) => {
  const dispatch = useDispatch();
  const icon = getToastIcon();
  const message = getToastMessage(conversation);
  const callerID = getCallerIDFromConversation(conversation);

  const handleViewClick = () => {
    dispatch(setSelectedCallerID(callerID));
  };

  return (
    <Box
      horizontal
      align="center"
      justify="space-between"
      data-name="conversations-toast"
    >
      <Box horizontal mr="12px" align="center">
        <Box mr="12px">{icon}</Box>
        <Text>{message}</Text>
      </Box>
      <ViewButton
        data-name="conversations-toast-view-button"
        mr="16px"
        onClick={handleButtonClick || handleViewClick}
      >
        {getToastButtonText(conversation.source)}
      </ViewButton>
    </Box>
  );
};

export default ConversationsToast;
